import React from "react";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import type { GAPromoTooltipContentFooterProps } from "./GAPromoTooltipContentFooter";
import { GAPromoTooltipContentFooter } from "./GAPromoTooltipContentFooter";

export type VerifiedDataToggleInfoTooltipContentProps = Pick<GAPromoTooltipContentFooterProps, "onGAWizardModalOpen">;

export class VerifiedDataToggleInfoTooltipContent extends React.Component<VerifiedDataToggleInfoTooltipContentProps> {
    render() {
        return (
            <div className="">
                <div className="verified-data-toggle-info-tooltip-element-inner-title">
                    <span>
                        <I18n>common.estimation.vs.verified.header.text</I18n>
                    </span>
                    <span className="verified-data-toggle-info-tooltip-element-inner-title-promotion">
                        <I18n>common.estimation.vs.verified.header.text.highlight</I18n>
                    </span>
                </div>
                <div className="verified-data-toggle-info-tooltip-element-inner-content">
                    <span>
                        <I18n>common.estimation.vs.verified.content.text</I18n>
                    </span>
                </div>
                <div className="verified-data-toggle-info-tooltip-element-inner-footer">
                    <GAPromoTooltipContentFooter
                        isAccountGAConnected={false}
                        onGAWizardModalOpen={this.props.onGAWizardModalOpen}
                    />
                </div>
            </div>
        );
    }
}
